import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { formConfig } from "../../../../configs/address-details-form.config";
import { ICON_TYPE } from '@spartacus/storefront';
import { ActivatedRoute } from '@angular/router';
import { GenAddressFormConfig } from 'src/app/generac/models/address-details.model';
import { GenInputType } from 'src/app/generac/enums/input-type.enum';
import { GenLoadingEnum } from 'src/app/generac/enums/loading.enum';
import { GenSingleConsignmentInfo, GenShippingGroup } from 'src/app/generac/models/cart.model';
import { GenSubscriptionProduct } from 'src/app/generac/models/subscription.model';
import { GenServiceProductType } from 'src/app/generac/enums/service-product-type';

@Component({
  selector: 'gen-address-details',
  templateUrl: './address-details.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class GenAddressDetailsComponent implements OnInit, AfterViewInit {
  @Input() formGroup: FormGroup;
  @Input() internalCalculation: boolean;
  @Input() isCartMixed: boolean;
  @Input() currentStepId: string;
  @Input() subscriptionProducts: GenSubscriptionProduct[];
  @Input() singleConsignmentInfo: GenSingleConsignmentInfo;
  @Input() checkoutInfo: any;
  @Input() cartCode: string;
  @Input() subsShippingGroup: GenShippingGroup;
  @Input() isServicePartsEnabled: boolean;
  @Output() loaded = new EventEmitter<GenLoadingEnum>();
  GenInputType = GenInputType;
  iconTypes = ICON_TYPE;
  panelOpenState: boolean[] = [];
  formConfig: GenAddressFormConfig[] = [formConfig[0]];
  atLeastOnePowerPlaySubs: boolean = false;
  subscriptionInfo: any[];

  constructor(
    private fb: FormBuilder,
    protected activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.initForm(this.checkoutInfo);
    if (this.subscriptionProducts?.length) {
      this.initSubscriptions();
      this.initPanel();
    }
  }

  ngAfterViewInit(): void {
    this.loaded.emit(GenLoadingEnum.Loaded);
  }

  getItemFormGroupByIndex(index: number) {
    return (<FormArray>this.formGroup.controls['subscriptions']).get([index]);
  }

  private initForm(checkoutInfo: any) {
    this.formConfig.forEach(field => {
      field.items.forEach(item => {
        const validators = item.validators?.length ? item.validators : [];
        this.formGroup.addControl(item.formControlName, new FormControl(checkoutInfo[item?.formControlName] || item.value, validators));
      });
    });
    if (this.subscriptionProducts?.length) {
      this.formGroup.addControl('subscriptions', this.fb.array([]));
    }
  }

  private initSubscriptions() {
    let i = 1;
    this.subscriptionInfo = this.subscriptionProducts.flatMap((item, index) => {
      const items = [];
      for (let q = 1; q <= (item.quantity || 1); q++) {
        items.push({
          ...item,
          ...item.subscriptions[q - 1],
          name: this.getItemTitle(item.sapMaterialNumber, q)
        });
      }
      return items;
    });
    this.atLeastOnePowerPlaySubs = this.subscriptionProducts.some(p =>
      p.serviceProductType == GenServiceProductType.RENEWAL
      || p.serviceProductType == GenServiceProductType.SELLING);
  }

  private getItemTitle(materialNumber: string, index: number) {
    if (materialNumber == 'POWERPLAYAPIRENEW') {
      return 'API PowerPlay Renew';
    }
    return this.subscriptionProducts.find(subscription => subscription.sapMaterialNumber == materialNumber)?.name + `${' #' + (index)}`;
  }

  private initPanel() {
    if (this.activatedRoute.snapshot.queryParams?.index && this.activatedRoute.snapshot.queryParams?.materialNumber) {
      const subscriptionsFiteredByMaterialNumber = this.subscriptionInfo.filter(subscription =>
        subscription.sapMaterialNumber == this.activatedRoute.snapshot.queryParams?.materialNumber);
      const indexOfItem = this.subscriptionInfo.indexOf(subscriptionsFiteredByMaterialNumber[this.activatedRoute.snapshot.queryParams?.index]);
      this.panelOpenState[indexOfItem] = true;
    } else {
      this.panelOpenState[0] = true;
    }
  }

}
